// $(window).on('scroll', function() {
//   if ($(this).scrollTop() >= 60) {
//     $('.header-sticky-wrapper').addClass('fixed_header');
//   } else {
//     $('.header-sticky-wrapper').removeClass('fixed_header');
//   }
// });

$(window).on('scroll', function() {
  if (window.matchMedia('(min-width: 768px)').matches) {
    if ($(this).scrollTop() >= 60) {
      $('.header-sticky-wrapper').addClass('fixed_header');
    } else {
      $('.header-sticky-wrapper').removeClass('fixed_header');
    }
  } else {
    // Optional: remove class if window is resized below 768
    $('.header-sticky-wrapper').removeClass('fixed_header');
  }
});
